import { render, staticRenderFns } from "./w-3-6.vue?vue&type=template&id=51f91a66"
import script from "./w-3-6.vue?vue&type=script&lang=js"
export * from "./w-3-6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports